export default __webpack_public_path__ + "static/media/TERMINAL_ICON_13.7cd667aa.svg";